import {
  MarketingSection,
  SectionIntro,
  SectionTitle,
} from "@/components/marketing/MarketingSection";

export default function SuperShowcase() {
  return (
    <MarketingSection className="bg-white" innerClassName="text-center">
      <div className="mx-auto max-w-[850px]">
        <SectionTitle>This is what more looks like.</SectionTitle>
        <SectionIntro className="mx-auto !max-w-[760px]">
          One song, multiple versions, and exclusive extras. All together in one
          release your fans can explore.
        </SectionIntro>
      </div>
      <figure className="mx-auto mt-12 w-[min(1040px,100%)] overflow-hidden rounded-[24px] border border-marketing-line bg-[#F7F8FB]">
        <img
          src="/marketing/super-single-published-view.webp"
          alt="Published Time Travelers Super Single by Thunder Dawg showing the original, clean, and instrumental versions"
          loading="lazy"
          className="h-auto w-full"
        />
      </figure>
    </MarketingSection>
  );
}
